import { IDataProvider } from "./IDataProvider";

export type IPlaceListEntry = {
    id: string;
    place: string;
    checked?: boolean | null;
    order?: number;
};

export type IPlaceList = {
    id: string;
    name?: string | null;
    description?: string | null;
};

export function makeEmptyPlaceList(): IPlaceList {
    return {
        id: "",
        name: "",
        description: "",
    };
}

export function makeEmptyPlaceListEntry(props?: any): IPlaceListEntry {
    const entry = {
        id: "",
        place: "",
        checked: false,
        order: 0,
    };
    if (props) {
        Object.assign(entry, props);
    }
    return entry;
}

export abstract class IPlaceListTable extends IDataProvider<IPlaceList> {
    // Entries
    public abstract getEntries(placeId: string): Promise<IPlaceListEntry[]>;
    public abstract createEntry(listId: string, entry: IPlaceListEntry): Promise<IPlaceListEntry>;
    public abstract deleteEntry(id: string): Promise<void>;
    public abstract updateEntry(item: IPlaceListEntry): Promise<IPlaceListEntry | undefined>;
}
